import React, { useCallback, useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Image,
    Form,
    Button,
    NavLink,
    Nav,
    Spinner,
} from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import { Link, useParams } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Accordion from "react-bootstrap/Accordion";
import Modal from "react-bootstrap/Modal";
import config from "../../config";
import {
    createMarkup,
    formatNumber,
    getRatingPercentage,
} from "../../Utils/utils";
import { toast } from "react-toastify";
import debounce from "lodash.debounce";
import axios from "axios";
import { cache } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import CourseSchema from "../../Components/CourseSchema";


const CourseDetail = () => {
    const { seo_slug } = useParams();

    const [courseid, setCourseid] = useState(null);

    const [coursename, setCoursename] = useState("");

    const [coursecategory, setCoursecategory] = useState("");

    const [category_seo_slug, setCategory_seo_slug] = useState("");

    const [learners_enrolled, setLearners_enrolled] = useState("");

    const [courseimage, setCourseimage] = useState("");

    const [courseimagetitle, setCourseimagetitle] = useState("");

    const [coursedetailData, setCoursedetailData] = useState([]);

    const [course_overviewData, setCourse_overviewData] = useState([]);

    const [live_online_class_data, setLive_online_class_data] = useState([]);

    const [
        course_live_online_classroom_name,
        setCourse_live_online_classroom_name,
    ] = useState("");

    const [courserfee, setCourserfee] = useState("");

    const [coursediscount_fee, setCoursediscount_fee] = useState("");

    const [course_upcoming_batches, setCourse_upcoming_batches] = useState("");

    const [enterprise_training_data, setEnterprise_training_data] = useState([]);

    const [curriculumData, setCurriculumData] = useState([]);

    const [aboutcertificationData, setAboutcertificationData] = useState([]);

    const [learningobjectivesData, setLearningobjectivesData] = useState([]);

    const [prerequisitesData, setPrerequisitesData] = useState([]);

    const [faqData, setFaqData] = useState([]);

    const [coursestudentData, setCoursestudentData] = useState([]);

    const [total_cur, setTotal_cur] = useState(0);

    const [total_about, setTotal_about] = useState(0);

    const [total_learning, setTotal_learning] = useState(0);

    const [total_prerequisites, setTotal_prerequisites] = useState(0);

    const [total_faq, setTotal_faq] = useState(0);

    const [curriculumoffset, setCurriculumoffset] = useState(0);

    const [aboutoffset, setAboutoffset] = useState(0);

    const [learnoffset, setLearnoffset] = useState(0);

    const [prerequisitesoffset, setPrerequisitesoffset] = useState(0);

    const [faqoffset, setFaqoffset] = useState(0);

    const [
        growth_project_manager_first_title,
        setGrowth_project_manager_first_title,
    ] = useState("");

    const [
        growth_project_manager_first_image,
        setGrowth_project_manager_first_image,
    ] = useState("");

    const [
        growth_project_manager_first_image_title,
        setGrowth_project_manager_first_image_title,
    ] = useState("");

    const [
        growth_project_manager_second_title,
        setGrowth_project_manager_second_title,
    ] = useState("");

    const [
        growth_project_manager_second_image,
        setGrowth_project_manager_second_image,
    ] = useState("");

    const [
        growth_project_manager_second_image_title,
        setGrowth_project_manager_second_image_title,
    ] = useState("");

    const [
        growth_project_manager_demand_title,
        setGrowth_project_manager_demand_title,
    ] = useState("");

    const [
        growth_project_manager_demand_description,
        setGrowth_project_manager_demand_description,
    ] = useState("");

    const [growth_project_lead_first_title, setGrowth_project_lead_first_title] =
        useState("");

    const [growth_project_lead_first_image, setGrowth_project_lead_first_image] =
        useState("");

    const [
        growth_project_lead_first_image_title,
        setGrowth_project_lead_first_image_title,
    ] = useState("");

    const [
        growth_project_lead_second_title,
        setGrowth_project_lead_second_title,
    ] = useState("");

    const [
        growth_project_lead_second_image,
        setGrowth_project_lead_second_image,
    ] = useState("");

    const [
        growth_project_lead_second_image_title,
        setGrowth_project_lead_second_image_title,
    ] = useState("");

    const [
        growth_project_lead_demand_title,
        setGrowth_project_lead_demand_title,
    ] = useState("");

    const [
        growth_project_lead_demand_description,
        setGrowth_project_lead_demand_description,
    ] = useState("");

    const [growth_pmo_lead_first_title, setGrowth_pmo_lead_first_title] =
        useState("");

    const [growth_pmo_lead_first_image, setGrowth_pmo_lead_first_image] =
        useState("");

    const [
        growth_pmo_lead_first_image_title,
        setGrowth_pmo_lead_first_image_title,
    ] = useState("");

    const [growth_pmo_lead_second_title, setGrowth_pmo_lead_second_title] =
        useState("");

    const [growth_pmo_lead_second_image, setGrowth_pmo_lead_second_image] =
        useState("");

    const [
        growth_pmo_lead_second_image_title,
        setGrowth_pmo_lead_second_image_title,
    ] = useState("");

    const [growth_pmo_lead_demand_title, setGrowth_pmo_lead_demand_title] =
        useState("");

    const [
        growth_pmo_lead_demand_description,
        setGrowth_pmo_lead_demand_description,
    ] = useState("");

    const [
        growth_project_director_first_title,
        setGrowth_project_director_first_title,
    ] = useState("");

    const [
        growth_project_director_first_image,
        setGrowth_project_director_first_image,
    ] = useState("");

    const [
        growth_project_director_first_image_title,
        setGrowth_project_director_first_image_title,
    ] = useState("");

    const [
        growth_project_director_second_title,
        setGrowth_project_director_second_title,
    ] = useState("");

    const [
        growth_project_director_second_image,
        setGrowth_project_director_second_image,
    ] = useState("");

    const [
        growth_project_director_second_image_title,
        setGrowth_project_director_second_image_title,
    ] = useState("");

    const [
        growth_project_director_demand_title,
        setGrowth_project_director_demand_title,
    ] = useState("");

    const [
        growth_project_director_demand_description,
        setGrowth_project_director_demand_description,
    ] = useState("");

    const [overview_title, setOverview_title] = useState("");

    const [curriculum_title, setCurriculum_title] = useState("");

    const [about_certification_title, setAbout_certification_title] =
        useState("");

    const [learning_objectives_title, setLearning_objectives_title] =
        useState("");

    const [prerequisites_title, setPrerequisites_title] = useState("");

    const [faq_title, setFaq_title] = useState("");

    const [career_growth_title, setCareer_growth_title] = useState("");

    const [certificate_image, setCertificate_image] = useState("");

    const [certificate_image_title, setCertificate_image_title] = useState("");

    const [trustedbydata, setTrustedbydata] = useState([]);

    // Course Detail Download Syllabus
    const [isSubmittingSyllabus, setIsSubmittingSyllabus] = useState(false);
    const [sfirstname, setSFirstname] = useState("");
    const [slastname, setSLastname] = useState("");
    const [semail, setSEmail] = useState("");
    const [sphonenumber, setSPhonenumber] = useState("");

    // Course Detail Download Curriculum
    const [isSubmittingCurriculum, setIsSubmittingCurriculum] = useState(false);
    const [cfirstname, setCFirstname] = useState("");
    const [clastname, setCLastname] = useState("");
    const [cemail, setCEmail] = useState("");
    const [cphonenumber, setCPhonenumber] = useState("");

    // Course Detail Download Sill up your terms
    const [skill_firstname, setSkill_Firstname] = useState("");
    const [skill_lastname, setSkill_Lastname] = useState("");
    const [skill_email, setSkill_Email] = useState("");
    const [skill_phonenumber, setSkill_Phonenumber] = useState("");
    const [skill_query, setSkill_Query] = useState("");

    // Course Detail Talk to our advisor
    const [isSubmittingTalk, setIsSubmittingTalk] = useState(false);
    const [talk_fullname, setTalk_Fullname] = useState("");
    const [talk_email, setTalk_Email] = useState("");
    const [talk_phonenumber, setTalk_Phonenumber] = useState("");

    // Meta Title, Description and Keyword Or Canonical URL
    const [meta_title, setMeta_title] = useState("");
    const [meta_description, setMeta_description] = useState("");
    const [meta_keyword, setMeta_keyword] = useState("");
    const [canonical_url, setCanonical_url] = useState("");

    // Zoho Lead Source
    const [leadSource, setLeadSource] = useState("Direct");
    const [leadCourseName, setLeadCourseName] = useState("");
    const [campaignId, setCampaignId] = useState("");

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    // Syllabus All Validations
    const syllabusvalidate = () => {
        const newErrors = {};

        if (!sfirstname) {
            newErrors.sfirstname = "First Name is required";
        }

        if (!slastname) {
            newErrors.slastname = "Last Name is required";
        }

        if (!semail) {
            newErrors.semail = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(semail)) {
            newErrors.semail = "Email address is invalid";
        }

        if (!sphonenumber) {
            newErrors.sphonenumber = "Phone Number is required";
        }

        return newErrors;
    };

    // Curriculum All Validations
    const curriculumvalidate = () => {
        const newErrors = {};

        if (!cfirstname) {
            newErrors.cfirstname = "First Name is required";
        }

        if (!clastname) {
            newErrors.clastname = "Last Name is required";
        }

        if (!cemail) {
            newErrors.cemail = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(cemail)) {
            newErrors.cemail = "Email address is invalid";
        }

        if (!cphonenumber) {
            newErrors.cphonenumber = "Phone Number is required";
        }

        return newErrors;
    };

    // Skill All Validations
    const skillvalidate = () => {
        const newErrors = {};

        if (!skill_firstname) {
            newErrors.skill_firstname = "First Name is required";
        }

        if (!skill_lastname) {
            newErrors.skill_lastname = "Last Name is required";
        }

        if (!skill_email) {
            newErrors.skill_email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(skill_email)) {
            newErrors.skill_email = "Email address is invalid";
        }

        if (!skill_phonenumber) {
            newErrors.skill_phonenumber = "Phone Number is required";
        }

        if (!skill_query) {
            newErrors.skill_query = "Query is required";
        }

        return newErrors;
    };

    // Talk All Validations
    const talkvalidate = () => {
        const newErrors = {};

        if (!talk_fullname) {
            newErrors.talk_fullname = "Full Name is required";
        } else if (talk_fullname.trim().split(" ").length < 2) {
            newErrors.talk_fullname = "Enter both first and last name";
        }

        if (!talk_email) {
            newErrors.talk_email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(talk_email)) {
            newErrors.talk_email = "Email address is invalid";
        }

        if (!talk_phonenumber) {
            newErrors.talk_phonenumber = "Phone Number is required";
        }

        return newErrors;
    };

    useEffect(() => {
        document.title = `Course Detail | Agile Seekers`;
        document.getElementById("bodywrap").className = "coudetmain";

        // Zoho Lead Details Start
        const params = new URLSearchParams(window.location.search);

        const source = params.get("utm_source");       // google ads
        const campaign_id = params.get("utm_id");

        if (source) {
            setLeadSource(`Google Ads`);
            setCampaignId(campaign_id);
        }
        // Zoho Lead Details End

        // Define your API URL
        const apiUrl = `${config.API_BASE_URL}/course_details`;

        // Define your API URL
        const home_apiUrl = `${config.API_BASE_URL}/home`;

        // Prepare the request payload
        const requestData = {
            seo_slug: seo_slug,
        };

        // Make the POST request
        fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status === 1) {
                    setCourseid(response.data.id);

                    setCoursename(response.data.name);

                    setCoursecategory(response.data.category_name);

                    setCategory_seo_slug(response.data.category_seo_slug);

                    setLearners_enrolled(response.data.learners_enrolled);

                    setCourseimage(response.data.image);

                    setCourseimagetitle(response.data.image_title);

                    setCoursedetailData(response.data.course_detail);

                    setCourse_overviewData(response.data.course_overview);

                    setLive_online_class_data(response.data.live_online_class_data);

                    setCourse_live_online_classroom_name(
                        response.data.live_online_classroom_name
                    );

                    setCourse_upcoming_batches(response.data.upcoming_batches);

                    setCourserfee(response.data.fee);

                    setCoursediscount_fee(response.data.discount_fee);

                    setEnterprise_training_data(response.data.enterprise_training_data);

                    setTotal_cur(response.data.total_cur);

                    setCurriculumData(response.data.curriculum);

                    setTotal_about(response.data.total_about);

                    setAboutcertificationData(response.data.about_certification);

                    setTotal_learning(response.data.total_learning);

                    setLearningobjectivesData(response.data.learning_objectives);

                    setTotal_prerequisites(response.data.total_prerequisites);

                    setPrerequisitesData(response.data.prerequisites);

                    setTotal_faq(response.data.total_faq);

                    setFaqData(response.data.faq);

                    setCoursestudentData(response.data.course_student);

                    setGrowth_project_manager_first_title(
                        response.data.growth_project_manager_first_title
                    );

                    setGrowth_project_manager_first_image(
                        response.data.growth_project_manager_first_image
                    );

                    setGrowth_project_manager_first_image_title(
                        response.data.growth_project_manager_first_image_title
                    );

                    setGrowth_project_manager_second_title(
                        response.data.growth_project_manager_second_title
                    );

                    setGrowth_project_manager_second_image(
                        response.data.growth_project_manager_second_image
                    );

                    setGrowth_project_manager_second_image_title(
                        response.data.growth_project_manager_second_image_title
                    );

                    setGrowth_project_manager_demand_title(
                        response.data.growth_project_manager_demand_title
                    );

                    setGrowth_project_manager_demand_description(
                        response.data.growth_project_manager_demand_description
                    );

                    setGrowth_project_lead_first_title(
                        response.data.growth_project_lead_first_title
                    );

                    setGrowth_project_lead_first_image(
                        response.data.growth_project_lead_first_image
                    );

                    setGrowth_project_lead_first_image_title(
                        response.data.growth_project_lead_first_image_title
                    );

                    setGrowth_project_lead_second_title(
                        response.data.growth_project_lead_second_title
                    );

                    setGrowth_project_lead_second_image(
                        response.data.growth_project_lead_second_image
                    );

                    setGrowth_project_lead_second_image_title(
                        response.data.growth_project_lead_second_image_title
                    );

                    setGrowth_project_lead_demand_title(
                        response.data.growth_project_lead_demand_title
                    );

                    setGrowth_project_lead_demand_description(
                        response.data.growth_project_lead_demand_description
                    );

                    setGrowth_pmo_lead_first_title(
                        response.data.growth_pmo_lead_first_title
                    );

                    setGrowth_pmo_lead_first_image(
                        response.data.growth_pmo_lead_first_image
                    );

                    setGrowth_pmo_lead_first_image_title(
                        response.data.growth_pmo_lead_first_image_title
                    );

                    setGrowth_pmo_lead_second_title(
                        response.data.growth_pmo_lead_second_title
                    );

                    setGrowth_pmo_lead_second_image(
                        response.data.growth_pmo_lead_second_image
                    );

                    setGrowth_pmo_lead_second_image_title(
                        response.data.growth_pmo_lead_second_image_title
                    );

                    setGrowth_pmo_lead_demand_title(
                        response.data.growth_pmo_lead_demand_title
                    );

                    setGrowth_pmo_lead_demand_description(
                        response.data.growth_pmo_lead_demand_description
                    );

                    setGrowth_project_director_first_title(
                        response.data.growth_project_director_first_title
                    );

                    setGrowth_project_director_first_image(
                        response.data.growth_project_director_first_image
                    );

                    setGrowth_project_director_first_image_title(
                        response.data.growth_project_director_first_image_title
                    );

                    setGrowth_project_director_second_title(
                        response.data.growth_project_director_second_title
                    );

                    setGrowth_project_director_second_image(
                        response.data.growth_project_director_second_image
                    );

                    setGrowth_project_director_second_image_title(
                        response.data.growth_project_director_second_image_title
                    );

                    setGrowth_project_director_demand_title(
                        response.data.growth_project_director_demand_title
                    );

                    setGrowth_project_director_demand_description(
                        response.data.growth_project_director_demand_description
                    );

                    setOverview_title(response.data.overview_title);

                    setCurriculum_title(response.data.curriculum_title);

                    setAbout_certification_title(response.data.about_certification_title);

                    setLearning_objectives_title(response.data.learning_objectives_title);

                    setPrerequisites_title(response.data.prerequisites_title);

                    setFaq_title(response.data.faq_title);

                    setCareer_growth_title(response.data.career_growth_title);

                    setCertificate_image(response.data.certificate_image);

                    setCertificate_image_title(response.data.certificate_image_title);

                    setMeta_title(response.data.meta_title);

                    setMeta_description(response.data.meta_description);

                    setMeta_keyword(response.data.meta_keyword);

                    setCanonical_url(response.data.canonical_url);
                } else {
                    setError("Failed to load content");
                    console.error("Error:", response.message);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Fetch Error:", error);
            });

        // Make Home the POST request using axios
        axios
            .post(home_apiUrl, {})
            .then((response) => {
                if (response.data.status === 1) {
                    setTrustedbydata(response.data.data.trusted_by);
                } else {
                    setError("Failed to load content");
                    console.error("Error:", response.data.message);
                }
                setLoading(false);
            })
            .catch((error) => {
                console.error("Axios Error:", error);
            });


        // Zoho Lead Course Name Condition
        if ("leading-safe-agilist-certification-training" === seo_slug) {
            setLeadCourseName("SAFe Agilist(SA)");
        } else if ("safe-product-owner-product-manager-popm-certification" === seo_slug) {
            setLeadCourseName("SAFe POPM");
        } else if ("safe-scrum-master-certification" === seo_slug) {
            setLeadCourseName("SSM");
        } else if ("safe-advanced-scrum-master-certification-training" === seo_slug) {
            setLeadCourseName("SASM");
        } else if ("certified-scrum-master-csm-certification-training" === seo_slug) {
            setLeadCourseName("CSM");
        } else if ("professional-scrum-master-psm-certification-training" === seo_slug) {
            setLeadCourseName("PSM");
        } else if ("certified-agile-coach-icp-acc-certification-training" === seo_slug) {
            setLeadCourseName("ICP-ACC");
        } else if ("safe-release-train-engineer-certification-training" === seo_slug) {
            setLeadCourseName("RTE");
        } else if ("kanban-system-design-certification-training" === seo_slug) {
            setLeadCourseName("KMP 1");
        } else if ("kanban-management-professional-certification-training" === seo_slug) {
            setLeadCourseName("KMP 2");
        } else if ("agile-and-scrum/cspo-certification-training" === seo_slug) {
            setLeadCourseName("CSPO");
        }


    }, []);

    // Meta Title
    // let metaTag = document.querySelector("meta[name='title']");
    // if (metaTag) {
    //     metaTag.setAttribute("content", meta_title); // Update meta title tag content
    // }

    document.title = `${meta_title} | Agile Seekers`;

    // Meta Description
    // let metaDescription = document.querySelector("meta[name='description']");
    // if (metaDescription) {
    //     metaDescription.setAttribute("content", meta_description); // Update meta description tag content
    // }

    // Meta Keywords
    // let metaKeywords = document.querySelector("meta[name='keywords']");
    // if (metaKeywords) {
    //     metaKeywords.setAttribute("content", meta_keyword); // Update meta keywords tag content
    // }

    // Canonical URL
    // let canonicalUrl = document.querySelector("link[rel='canonical']");
    // if (canonicalUrl) {
    //     canonicalUrl.setAttribute("href", canonical_url); // Update meta canonical tag content
    // }



    // Download Syllabus
    const syllabus_submit = async () => {
        const validationErrors = syllabusvalidate();

        if (Object.keys(validationErrors).length === 0) {
            setIsSubmittingSyllabus(true); // Start the loading state
            let item = {};
            item.course_id = courseid;
            item.first_name = sfirstname;
            item.last_name = slastname;
            item.email = semail;
            item.phone_number = sphonenumber;
            item.course_name = coursename;
            item.page_url = window.location.href;

            setErrors({});

            try {
                let response = await fetch(
                    `${config.API_BASE_URL}/course_download_syllabus`,
                    {
                        method: "post",
                        body: JSON.stringify(item),
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                response = await response.json();

                if (response.status === 1) {

                    // Zoho Lead API Code Start
                    const payload = {
                        data: [
                            {
                                Company: "Agile",
                                First_Name: sfirstname,
                                Last_Name: slastname,
                                Email: semail,
                                Phone: sphonenumber,
                                Lead_Status: "New",
                                Lead_Source: leadSource,
                                Form_Name: "Download Syllabus Form",
                                Page_name: window.location.href,
                                Social_Lead_ID: campaignId,
                                Course_Name1: leadCourseName,
                            },
                        ],
                        trigger: ["approval", "workflow", "blueprint"],
                    };

                    try {
                        const response = await fetch(`${config.API_BASE_URL}/zoho/course_download_syllabus`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        });

                        const result = await response.json();

                        if (result.status === 1) {
                            setSFirstname("");
                            setSLastname("");
                            setSEmail("");
                            setSPhonenumber("");

                            setShowSyll(false);

                            // toast.success(result.message);
                        } else {
                            // toast.error(result.message);
                            console.error("Zoho Error:", result);
                        }
                    } catch (error) {
                        console.error("Fetch error:", error);
                    } finally {
                        setIsSubmittingSyllabus(false); // End the loading state
                    }
                    // Zoho Lead API Code End

                    setShowSyll(false);
                    // Display alert with message
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                toast.error("An unexpected error occurred.");
            } finally {
                setIsSubmittingSyllabus(false); // End the loading state
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // Download Curriculum
    const curriculum_submit = async () => {
        const validationErrors = curriculumvalidate();

        if (Object.keys(validationErrors).length === 0) {
            setIsSubmittingCurriculum(true); // Start the loading state
            let item = {};
            item.course_id = courseid;
            item.first_name = cfirstname;
            item.last_name = clastname;
            item.email = cemail;
            item.phone_number = cphonenumber;
            item.course_name = coursename;
            item.page_url = window.location.href;

            setErrors({});

            try {
                let response = await fetch(
                    `${config.API_BASE_URL}/course_download_curriculum`,
                    {
                        method: "post",
                        body: JSON.stringify(item),
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                response = await response.json();

                if (response.status === 1) {

                    // Zoho Lead API Code Start
                    const payload = {
                        data: [
                            {
                                Company: "Agile",
                                First_Name: cfirstname,
                                Last_Name: clastname,
                                Email: cemail,
                                Phone: cphonenumber,
                                Lead_Status: "New",
                                Lead_Source: leadSource,
                                Form_Name: "Download Curriculum Form",
                                Page_name: window.location.href,
                                Social_Lead_ID: campaignId,
                                Course_Name1: leadCourseName,
                            },
                        ],
                        trigger: ["approval", "workflow", "blueprint"],
                    };

                    try {
                        const response = await fetch(`${config.API_BASE_URL}/zoho/course_download_curriculum`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        });

                        const result = await response.json();

                        if (result.status === 1) {
                            setCFirstname("");
                            setCLastname("");
                            setCEmail("");
                            setCPhonenumber("");

                            setShow(false);

                            // toast.success(result.message);
                        } else {
                            // toast.error(result.message);
                            console.error("Zoho Error:", result);
                        }
                    } catch (error) {
                        console.error("Fetch error:", error);
                    } finally {
                        setIsSubmittingCurriculum(false); // End the loading state
                    }
                    // Zoho Lead API Code End

                    setShow(false);
                    // Display alert with message
                    toast.success(response.message);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                toast.error("An unexpected error occurred.");
            } finally {
                setIsSubmittingCurriculum(false); // End the loading state
            }


        } else {
            setErrors(validationErrors);
        }
    };

    // Skill up your teams
    const skillup_submit = async () => {
        const validationErrors = skillvalidate();

        if (Object.keys(validationErrors).length === 0) {
            let item = {};
            item.course_id = courseid;
            item.first_name = skill_firstname;
            item.last_name = skill_lastname;
            item.email = skill_email;
            item.phone_number = skill_phonenumber;
            item.query = skill_query;

            try {

                let response = await fetch(`${config.API_BASE_URL}/skill_up_your_team`, {
                    method: "post",
                    body: JSON.stringify(item),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                response = await response.json();

                if (response.status === 1) {

                    // Zoho Lead API Code Start
                    const payload = {
                        data: [
                            {
                                Company: "Agile",
                                First_Name: skill_firstname,
                                Last_Name: skill_lastname,
                                Email: skill_email,
                                Phone: skill_phonenumber,
                                Lead_Status: "New",
                                Lead_Source: leadSource,
                                Form_Name: "Skill up your teams Form",
                                Page_name: window.location.href,
                                Social_Lead_ID: campaignId,
                                Course_Name1: leadCourseName,
                            },
                        ],
                        trigger: ["approval", "workflow", "blueprint"],
                    };

                    try {
                        const response = await fetch(`${config.API_BASE_URL}/zoho/skill_up_your_team`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        });

                        const result = await response.json();

                        if (result.status === 1) {
                            setErrors({});

                            setSkill_Firstname("");
                            setSkill_Lastname("");
                            setSkill_Email("");
                            setSkill_Phonenumber("");
                            setSkill_Query("");

                            setShowSkill(false);

                            // toast.success(result.message);
                        } else {
                            // toast.error(result.message);
                            console.error("Zoho Error:", result);
                        }
                    } catch (error) {
                        console.error("Fetch error:", error);
                    }
                    // Zoho Lead API Code End

                    // Display alert with message
                    toast.success(response.message);

                    setShowSkill(false);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                toast.error("An unexpected error occurred.");
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // Talk to our advisor
    const talk_submit = async () => {
        const validationErrors = talkvalidate();

        if (Object.keys(validationErrors).length === 0) {
            setIsSubmittingTalk(true)
            let item = {};
            item.course_id = courseid;
            item.full_name = talk_fullname;
            item.email = talk_email;
            item.phone_number = talk_phonenumber;
            item.course_name = coursename;
            item.page_url = window.location.href;


            setErrors({});
            try {

                let response = await fetch(`${config.API_BASE_URL}/talk_to_our_advisor`, {
                    method: "post",
                    body: JSON.stringify(item),
                    headers: {
                        "Content-Type": "application/json",
                    },
                });

                response = await response.json();

                if (response.status === 1) {

                    // Split the name into an array
                    const nameParts = talk_fullname.split(" ");

                    // Extract the first name and last name
                    const zoho_firstname = nameParts[0];
                    const zoho_lastname = nameParts[1];

                    // Zoho Lead API Code Start
                    const payload = {
                        data: [
                            {
                                Company: "Agile",
                                First_Name: zoho_firstname,
                                Last_Name: zoho_lastname,
                                Email: talk_email,
                                Phone: talk_phonenumber,
                                Lead_Status: "New",
                                Lead_Source: leadSource,
                                Form_Name: "Talk to our advisor Form",
                                Page_name: window.location.href,
                                Social_Lead_ID: campaignId,
                                Course_Name1: leadCourseName,
                            },
                        ],
                        trigger: ["workflow",],
                    };

                    try {
                        const response = await fetch(`${config.API_BASE_URL}/zoho/talk_to_our_advisor`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(payload),
                        });

                        const result = await response.json();

                        if (result.status === 1) {
                            setErrors({});

                            setTalk_Fullname("");
                            setTalk_Email("");
                            setTalk_Phonenumber("");

                            setShowThank(true);
                            // toast.success(result.message);
                        } else {
                            // toast.error(result.message);
                            console.error("Zoho Error:", result);
                        }
                    } catch (error) {
                        console.error("Fetch error:", error);
                    } finally {
                        setIsSubmittingTalk(false); // End the loading state
                    }
                    // Zoho Lead API Code End

                    setShowThank(true);
                } else {
                    toast.error(response.message);
                }
            } catch (error) {
                console.error("Error submitting form:", error);
                toast.error("An unexpected error occurred.");
            } finally {
                setIsSubmittingTalk(false); // End the loading state
            }
        } else {
            setErrors(validationErrors);
        }
    };

    // Leading safe certification course curriculum View More
    const curriculum_view_more = useCallback(
        debounce((curriculum_requestData) => {
            const apiUrl = `${config.API_BASE_URL}/add_more_course_curriculum`;

            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(curriculum_requestData),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === 1 && Array.isArray(response.data)) {
                        if (curriculum_requestData.offset === 0) {
                            setCurriculumData(response.data);
                        } else {
                            setCurriculumData((prevCurriculum) => [
                                ...prevCurriculum,
                                ...response.data,
                            ]);
                        }
                    } else {
                        setError("Failed to load content");
                        console.error("Error:", response.message || "Unknown error");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Fetch error");
                    console.error("Fetch Error:", error);
                    setLoading(false);
                });
        }),
        []
    );

    const curriculum_handleViewMore = () => {
        const newOffset = curriculumoffset + 4;
        setCurriculumoffset(newOffset);
        const curriculum_requestData = {
            offset: newOffset,
            course_id: courseid,
        };
        curriculum_view_more(curriculum_requestData);
    };

    // About Agile Seekers Certificates
    const about_view_more = useCallback(
        debounce((about_requestData) => {
            const apiUrl = `${config.API_BASE_URL}/add_more_course_about_certification`;
            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(about_requestData),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === 1 && Array.isArray(response.data)) {
                        if (about_requestData.offset === 0) {
                            setAboutcertificationData(response.data);
                        } else {
                            setAboutcertificationData((prevAbout) => [
                                ...prevAbout,
                                ...response.data,
                            ]);
                        }
                    } else {
                        setError("Failed to load content");
                        console.error("Error:", response.message || "Unknown error");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Fetch error");
                    console.error("Fetch Error:", error);
                    setLoading(false);
                });
        }),
        []
    );

    const about_handleViewMore = () => {
        const newOffset = aboutoffset + 4;
        setAboutoffset(newOffset);
        const about_requestData = {
            offset: newOffset,
            course_id: courseid,
        };
        about_view_more(about_requestData);
    };

    // What you will learn
    const learn_view_more = useCallback(
        debounce((learn_requestData) => {
            const apiUrl = `${config.API_BASE_URL}/add_more_course_learning_objectives`;

            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(learn_requestData),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === 1 && Array.isArray(response.data)) {
                        if (learn_requestData.offset === 0) {
                            setLearningobjectivesData(response.data);
                        } else {
                            setLearningobjectivesData((prevData) => [
                                ...prevData,
                                ...response.data,
                            ]);
                        }
                    } else {
                        setError("Failed to load content");
                        console.error("Error:", response.message || "Unknown error");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Fetch error");
                    console.error("Fetch Error:", error);
                    setLoading(false);
                });
        }),
        []
    );

    const learn_handleViewMore = () => {
        const newOffset = learnoffset + 10;
        setLearnoffset(newOffset);
        const learn_requestData = {
            offset: newOffset,
            course_id: courseid,
        };
        learn_view_more(learn_requestData);
    };

    // Prerequisites and Eligibility
    const prerequisites_view_more = useCallback(
        debounce((prerequisites_requestData) => {
            const apiUrl = `${config.API_BASE_URL}/add_more_course_prerequisites`;

            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(prerequisites_requestData),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === 1 && Array.isArray(response.data)) {
                        if (prerequisites_requestData.offset === 0) {
                            setPrerequisitesData(response.data);
                        } else {
                            setPrerequisitesData((prevPrerequisites) => [
                                ...prevPrerequisites,
                                ...response.data,
                            ]);
                        }
                    } else {
                        setError("Failed to load content");
                        console.error("Error:", response.message || "Unknown error");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Fetch error");
                    console.error("Fetch Error:", error);
                    setLoading(false);
                });
        }),
        []
    );

    const prerequisites_handleViewMore = () => {
        const newOffset = prerequisitesoffset + 4;
        setPrerequisitesoffset(newOffset);
        const prerequisites_requestData = {
            offset: newOffset,
            course_id: courseid,
        };
        prerequisites_view_more(prerequisites_requestData);
    };

    // Frequently Asked Quesions
    const faq_view_more = useCallback(
        debounce((faq_requestData) => {
            const apiUrl = `${config.API_BASE_URL}/add_more_course_faq`;

            fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(faq_requestData),
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status === 1 && Array.isArray(response.data)) {
                        if (faq_requestData.offset === 0) {
                            setFaqData(response.data);
                        } else {
                            setFaqData((prevFaq) => [...prevFaq, ...response.data]);
                        }
                    } else {
                        setError("Failed to load FAQs");
                        console.error("Error:", response.message || "Unknown error");
                    }
                    setLoading(false);
                })
                .catch((error) => {
                    setError("Fetch error");
                    console.error("Fetch Error:", error);
                    setLoading(false);
                });
        }),
        []
    );

    const faq_handleViewMore = () => {
        const newOffset = faqoffset + 4;
        setFaqoffset(newOffset);
        const faq_requestData = {
            offset: newOffset,
            course_id: courseid,
        };
        faq_view_more(faq_requestData);
    };

    const settings1 = {
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: "linear",
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        infinite: true,
        initialSlide: 1,
        arrows: false,
        buttons: false,
    };

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showsyll, setShowSyll] = useState(false);
    const handleCloseSyll = () => setShowSyll(false);
    const handleShowSyll = () => setShowSyll(true);

    // State to track the active section
    const [activeSection, setActiveSection] = useState("ccb1");

    // Handle the scroll and update the active section
    const handleClickScroll = (id) => {
        setActiveSection(id);
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };

    const [showSkill, setShowSkill] = useState(false);
    const handleCloseSkill = () => setShowSkill(false);
    const handleShowSkill = () => setShowSkill(true);

    const [showThank, setShowThank] = useState(false);
    const handleCloseThank = () => setShowThank(false);

    const [currentSection, setCurrentSection] = useState("");

    // Effect to handle scroll event
    useEffect(() => {
        const handleScroll = () => {
            let current = "";

            // Get all sections
            const sections = document.querySelectorAll(".ccbt-box > div");

            // Loop through sections to find the current one
            sections.forEach((section) => {
                const sectionTop = section.offsetTop;
                if (window.pageYOffset >= sectionTop - 200) {
                    current = section.getAttribute("id");
                }
            });

            // Set the current section in state
            setCurrentSection(current);
        };

        // Add event listener for scroll
        window.addEventListener("scroll", handleScroll);

        // Cleanup the event listener when component unmounts
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const course = {
        name: meta_title,
        description: meta_description,
        url: window.location.href,
        fee: courserfee.toString(),
        category: coursecategory.toString(),
    };

    return (
        <>
            <HelmetProvider>
                <CourseSchema data={course} />
            </HelmetProvider>

            <Navbar />

            <section className="cd-top-sec">
                <Container>
                    <Row className="cd-breadcrumb">
                        <Col>
                            <Link to="/">
                                <Image
                                    src={`${config.BASE_URL}/assets/images/home.svg`}
                                    className="img-fluid home"
                                    alt="home"
                                />
                            </Link>
                            <Image
                                src={`${config.BASE_URL}/assets/images/vs-back.png`}
                                className="img-fluid"
                                alt="vs-back"
                            />
                            <p>
                                {" "}
                                {loading
                                    ? "Loading..."
                                    : error
                                        ? error
                                        : coursecategory || "Course category not available"}
                            </p>
                            <Image
                                src={`${config.BASE_URL}/assets/images/vs-back.png`}
                                className="img-fluid"
                                alt="vs-back"
                            />
                            <p>
                                {" "}
                                {loading
                                    ? "Loading..."
                                    : error
                                        ? error
                                        : coursename || "Course name not available"}
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={7} lg={7}>
                            <h2 className="cd-maintitle">
                                {loading
                                    ? "Loading..."
                                    : error
                                        ? error
                                        : coursename || "Course name not available"}
                            </h2>

                            <div className="le-pink">
                                <div>
                                    <h5>{learners_enrolled}+</h5>
                                    <h6>Learners Enrolled</h6>
                                </div>
                            </div>

                            {loading ? (
                                <Col md={3} className="lpsingle">
                                    {" "}
                                    Loading...{" "}
                                </Col>
                            ) : error ? (
                                <Col md={3} className="lpsingle">
                                    {" "}
                                    {error}{" "}
                                </Col>
                            ) : coursedetailData.length > 0 ? (
                                coursedetailData.map((item, index) => (
                                    <div className="cd-tick-box" key={index}>
                                        <Image
                                            src={`${config.BASE_URL}/assets/images/tick.png`}
                                            className="img-fluid"
                                            alt="tick"
                                        />
                                        <p>{item.description}</p>
                                    </div>
                                ))
                            ) : (
                                <div className="cd-tick-box">
                                    <p>No Course Detail found</p>
                                </div>
                            )}

                            <div className="cd-top-btn">
                                <Link onClick={handleShowSyll} className="ds-btn">
                                    Download Syllabus
                                </Link>

                                <Link
                                    to={`/view-schedule/${courseid}`}
                                    className="vs-btn"
                                    onClick={() => {
                                        window.scrollTo(0, 0);
                                    }}
                                >
                                    View Schedule
                                </Link>
                            </div>

                            <Row>
                                <Col md={12} lg={12}>
                                    <div className="gt-review-box">
                                        <div>
                                            <div>
                                                <Image
                                                    src={`${config.BASE_URL}/assets/images/google-review.png`}
                                                    className="img-fluid"
                                                    alt="google-review"
                                                />
                                            </div>
                                            <div>
                                                <p>5 / 5</p>
                                            </div>
                                        </div>
                                        <div>
                                            <div>
                                                <Image
                                                    src={`${config.BASE_URL}/assets/images/trustpilot-review.png`}
                                                    className="img-fluid"
                                                    alt="trustpilot-review"
                                                />
                                            </div>
                                            <div>
                                                <p>4.9 / 5</p>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>

                        <Col
                            md={5}
                            lg={5}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <div className="cd-banner-social">
                                <div>
                                    <div>
                                        <Image
                                            src={`${config.BASE_URL}/assets/images/cu-google.svg`}
                                            className="img-fluid"
                                            alt="cu-google"
                                        />
                                        <p>5/5</p>
                                    </div>
                                    <div>
                                        <Image
                                            src={`${config.BASE_URL}/assets/images/cu-facebook.svg`}
                                            className="img-fluid"
                                            alt="cu-facebook"
                                        />
                                        <p>4.9/5</p>
                                    </div>
                                    <div>
                                        <Image
                                            src={`${config.BASE_URL}/assets/images/cu-reload.svg`}
                                            className="img-fluid"
                                            alt="cu-reload"
                                        />
                                        <p>5/5</p>
                                    </div>
                                </div>
                                <Image
                                    src={
                                        loading
                                            ? "Loading..."
                                            : error
                                                ? error
                                                : courseimage || "Course Image not available"
                                    }
                                    className="img-fluid"
                                    alt="cd-banner"
                                    title={courseimagetitle || "Course Image Title"}
                                />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="course-top-tab-box">
                <Container>
                    <Row>
                        <Col md={12} className="course-top-tab">
                            <div>
                                <Button
                                    className={currentSection === "ccb1" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb1")}
                                >
                                    Overview
                                </Button>
                                <Button
                                    className={currentSection === "ccb2" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb2")}
                                >
                                    Course Curriculum
                                </Button>
                                <Button
                                    className={currentSection === "ccb4" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb4")}
                                >
                                    About Certification
                                </Button>
                                <Button
                                    className={currentSection === "ccb3" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb3")}
                                >
                                    Enroll Now
                                </Button>
                                <Button
                                    className={currentSection === "ccb5" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb5")}
                                >
                                    Learning Objectives
                                </Button>
                                <Button
                                    className={currentSection === "ccb6" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb6")}
                                >
                                    Prerequisites
                                </Button>
                                <Button
                                    className={currentSection === "ccb8" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb8")}
                                >
                                    FAQ
                                </Button>
                                <NavLink
                                    href="tel:+919143964396"
                                    className={currentSection === "ccb7" ? "active" : ""}
                                    onClick={() => handleClickScroll("ccb7")}
                                >
                                    {" "}
                                    <Image
                                        src={`${config.BASE_URL}/assets/images/phone.gif`}
                                        className="img-fluid ccb7-phone"
                                        alt="cnt-phone"
                                    />{" "}
                                    +91 91 4396 4396
                                </NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="cousrse-content-box-top">
                <Container>
                    <Row>
                        <Col md={8} lg={8} className="ccbt-box">
                            <Row className="course-top-box" id="ccb1">
                                <Col md={12}>
                                    <h3>{overview_title}</h3>
                                    <Row>
                                        {loading ? (
                                            <Col md={6} className="cttli">
                                                Loading...
                                            </Col>
                                        ) : error ? (
                                            <Col md={6} className="cttli">
                                                {error}
                                            </Col>
                                        ) : course_overviewData.length > 0 ? (
                                            course_overviewData.map((item, index) => (
                                                <Col md={6} className="cttli" key={index}>
                                                    <Image
                                                        src={`${config.BASE_URL}/assets/images/shiled.png`}
                                                        className="img-fluid"
                                                        alt="shiled"
                                                    />
                                                    <p>{item.description}</p>
                                                </Col>
                                            ))
                                        ) : (
                                            <Col md={6} className="cttli">
                                                <p>No Course Overview found</p>
                                            </Col>
                                        )}
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col
                            md={4}
                            lg={4}
                            className="d-flex align-items-center justify-content-center"
                        >
                            <Row>
                                <Col md={12} className="over-certi">
                                    <div>
                                        <Image
                                            src={certificate_image}
                                            className="img-fluid"
                                            alt="certificate"
                                            title={
                                                certificate_image_title || "Certificate Image Title"
                                            }
                                        />
                                        <Link to="">Shareable on Linkedin</Link>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="cousrse-content-box">
                <Container>
                    <Row>
                        <Col md={8} lg={8} className="ccbt-box">
                            {/* Leading safe certification course curriculum */}
                            <Row className="cousrse-gen-accordian" id="ccb2">
                                <Col md={12}>
                                    <div className="cga-top">
                                        <h3>{curriculum_title}</h3>
                                        <div>
                                            <Link onClick={handleShow} state={{ id: courseid }}>
                                                Download Curriculum{" "}
                                                <Image
                                                    src={`${config.BASE_URL}/assets/images/download.png`}
                                                    className="img-fluid"
                                                    alt="download"
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="cga-acc-box">
                                        <Accordion defaultActiveKey="0">
                                            {loading ? (
                                                <Accordion.Item> Loading... </Accordion.Item>
                                            ) : error ? (
                                                <Accordion.Item> {error} </Accordion.Item>
                                            ) : curriculumData.length > 0 ? (
                                                curriculumData.map((item, index) => (
                                                    <Accordion.Item
                                                        id={item.id}
                                                        key={index}
                                                        eventKey={index.toString()}
                                                    >
                                                        <Accordion.Header>
                                                            {index + 1}. {item.name}
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            <p
                                                                dangerouslySetInnerHTML={createMarkup(
                                                                    item.description
                                                                )}
                                                            ></p>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                ))
                                            ) : (
                                                <Accordion.Item>
                                                    {" "}
                                                    <p>No Curriculum found.</p>{" "}
                                                </Accordion.Item>
                                            )}
                                        </Accordion>
                                    </div>

                                    {curriculumData.length < total_cur && (
                                        <div className="lpvm-btn">
                                            <Link onClick={curriculum_handleViewMore}>View More</Link>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <Row className="course-fee-main" id="ccb3">
                                <h3>Course Fee</h3>
                                <Col md={12}>
                                    <Row>
                                        <Col md={12} lg={6} className="cf-box">
                                            <div className="cfm-box">
                                                <div>
                                                    <h4>Live online classroom</h4>
                                                    <h5>Learn in Expert-Led Live Sessions</h5>
                                                    <h4>{course_live_online_classroom_name}</h4>

                                                    {loading ? (
                                                        <Accordion.Item> Loading... </Accordion.Item>
                                                    ) : error ? (
                                                        <Accordion.Item> {error} </Accordion.Item>
                                                    ) : live_online_class_data.length > 0 ? (
                                                        live_online_class_data.map((item, index) => (
                                                            <div className="cttli" key={index}>
                                                                <Image
                                                                    src={`${config.BASE_URL}/assets/images/shiled.png`}
                                                                    className="img-fluid"
                                                                    alt="shiled"
                                                                />
                                                                <p>{item.description}</p>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <Accordion.Item>
                                                            <p>No Live online class data found.</p>
                                                        </Accordion.Item>
                                                    )}

                                                    <h4>Upcoming Batches</h4>
                                                    <div className="ubbox">
                                                        <h5>{course_upcoming_batches}</h5>
                                                        <Link
                                                            to={`/view-schedule/${courseid}`}
                                                            onClick={() => {
                                                                requestAnimationFrame(() => {
                                                                    window.scrollTo(0, 0);
                                                                });
                                                            }}
                                                        >
                                                            View all schedule
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="enroll-box">
                                                    <div>
                                                        <h5>₹{formatNumber(coursediscount_fee)}</h5>
                                                        <h4>₹ {formatNumber(courserfee)} </h4>
                                                    </div>
                                                    <Link
                                                        to={`/view-schedule/${courseid}`}
                                                        onClick={() => {
                                                            requestAnimationFrame(() => {
                                                                window.scrollTo(0, 0);
                                                            });
                                                        }}
                                                    >
                                                        Enroll Now
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md={12} lg={6} className="cf-box">
                                            <div className="cfm-box">
                                                <div>
                                                    <h4>Enterprise Training</h4>
                                                    <h5>Upskill and Reskill Your Teams</h5>
                                                    <h4>Customized Corporate Training</h4>
                                                    {loading ? (
                                                        <Accordion.Item> Loading... </Accordion.Item>
                                                    ) : error ? (
                                                        <Accordion.Item> {error} </Accordion.Item>
                                                    ) : enterprise_training_data.length > 0 ? (
                                                        enterprise_training_data.map((item, index) => (
                                                            <div className="cttli" id={item.id} key={index}>
                                                                <Image
                                                                    src={`${config.BASE_URL}/assets/images/shiled.png`}
                                                                    className="img-fluid"
                                                                    alt="shiled"
                                                                />
                                                                <p>{item.description}</p>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <Accordion.Item>
                                                            <p>No Live online class data found.</p>
                                                        </Accordion.Item>
                                                    )}
                                                </div>
                                                <div className="sytbox">
                                                    <Link onClick={handleShowSkill}>
                                                        Skill Up Your Teams
                                                    </Link>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            {/* About Agile Seekers Certificates */}
                            <Row className="cousrse-gen-accordian" id="ccb4">
                                <Col md={12}>
                                    <div className="cga-top">
                                        <h3>{about_certification_title}</h3>
                                    </div>
                                    <div className={"cga-acc-box"}>
                                        <Accordion defaultActiveKey="0">
                                            {loading ? (
                                                <Accordion.Item> Loading... </Accordion.Item>
                                            ) : error ? (
                                                <Accordion.Item> {error} </Accordion.Item>
                                            ) : aboutcertificationData.length > 0 ? (
                                                aboutcertificationData.map((item, index) => (
                                                    <Accordion.Item
                                                        id={item.id}
                                                        key={index}
                                                        eventKey={index.toString()}
                                                    >
                                                        <Accordion.Header>
                                                            {index + 1}. {item.name}
                                                        </Accordion.Header>
                                                        <Accordion.Body>
                                                            <p
                                                                dangerouslySetInnerHTML={createMarkup(
                                                                    item.description
                                                                )}
                                                            ></p>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                ))
                                            ) : (
                                                <Accordion.Item>
                                                    {" "}
                                                    <p>No About Certification found.</p>{" "}
                                                </Accordion.Item>
                                            )}
                                        </Accordion>
                                    </div>

                                    {aboutcertificationData.length < total_about && (
                                        <div className="lpvm-btn">
                                            <Link onClick={about_handleViewMore}>View More</Link>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            <Row className="wl-main-box" id="ccb5">
                                <Col>
                                    <Row className={"learn-box"}>
                                        <Col md={12}>
                                            <h3>{learning_objectives_title}</h3>
                                        </Col>

                                        {loading ? (
                                            <Col md={12} lg={6} className="wlmain">
                                                {" "}
                                                Loading...{" "}
                                            </Col>
                                        ) : error ? (
                                            <Col md={12} lg={6} className="wlmain">
                                                {" "}
                                                {error}{" "}
                                            </Col>
                                        ) : learningobjectivesData.length > 0 ? (
                                            learningobjectivesData.map((item, index) => (
                                                <Col md={12} lg={6} className="wlmain" key={index}>
                                                    <div className="wlbox">
                                                        <div className="wlcont">
                                                            <h4>{item.name}</h4>
                                                            <p>{item.description}</p>
                                                        </div>
                                                        <div className="polygon">
                                                            <p>{(index + 1).toString().padStart(2, "0")}</p>
                                                            <Image
                                                                src={`${config.BASE_URL}/assets/images/polygon.png`}
                                                                className="img-fluid"
                                                                alt="polygon"
                                                            />
                                                        </div>
                                                    </div>
                                                </Col>
                                            ))
                                        ) : (
                                            <Col md={12} lg={6} className="wlmain">
                                                {" "}
                                                <p>No Learning Objectives found.</p>{" "}
                                            </Col>
                                        )}
                                    </Row>

                                    {learningobjectivesData.length < total_learning && (
                                        <div className="lpvm-btn mb-0">
                                            <Link onClick={learn_handleViewMore}>View More</Link>
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            {/* Prerequisites and Eligibility */}
                            <Row className="cousrse-tab-accordian" id="ccb6">
                                <Col md={12} className="cta-top">
                                    <h3>{prerequisites_title}</h3>
                                </Col>
                                <Col md={12}>
                                    <Row>
                                        <Col sm={12}>
                                            <div className={"cta-acc-box"}>
                                                <Accordion defaultActiveKey="0">
                                                    {loading ? (
                                                        <Accordion.Item>Loading...</Accordion.Item>
                                                    ) : error ? (
                                                        <Accordion.Item>{error}</Accordion.Item>
                                                    ) : prerequisitesData.length > 0 ? (
                                                        prerequisitesData.map((item, index) => (
                                                            <Accordion.Item
                                                                id={item.id}
                                                                key={index}
                                                                eventKey={index.toString()}
                                                            >
                                                                <Accordion.Header>
                                                                    {index + 1}. {item.name}
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <p
                                                                        dangerouslySetInnerHTML={createMarkup(
                                                                            item.description
                                                                        )}
                                                                    ></p>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        ))
                                                    ) : (
                                                        <Accordion.Item>
                                                            <p>No Prerequisites found.</p>
                                                        </Accordion.Item>
                                                    )}
                                                </Accordion>
                                            </div>

                                            {prerequisitesData.length < total_prerequisites && (
                                                <div className="lpvm-btn">
                                                    <Link onClick={prerequisites_handleViewMore}>
                                                        View More
                                                    </Link>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row className="sdcg-main">
                                <Col md={12}>
                                    <h3>{career_growth_title}</h3>
                                </Col>
                                <Col md={12}>
                                    <Tabs
                                        defaultActiveKey="project-manager"
                                        id="sdcg-tab"
                                        className="mb-3"
                                    >
                                        {/* Project Manager */}
                                        <Tab eventKey="project-manager" title="Project Manager">
                                            <Row>
                                                <Col md={6} className="tab-col-left">
                                                    <h4>{growth_project_manager_first_title}</h4>
                                                    <Image
                                                        src={growth_project_manager_first_image}
                                                        className="img-fluid"
                                                        alt="chart1"
                                                        title={
                                                            growth_project_manager_first_image_title ||
                                                            "Growth Project Manager First Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={6} className="tab-col-right">
                                                    <h4>{growth_project_manager_second_title}</h4>
                                                    <Image
                                                        src={growth_project_manager_second_image}
                                                        className="img-fluid"
                                                        alt="taimg"
                                                        title={
                                                            growth_project_manager_second_image_title ||
                                                            "Growth Project Manager Second Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={12} className="demand-box">
                                                    <h4>Demand</h4>
                                                    <div>
                                                        <Image
                                                            src={`${config.BASE_URL}/assets/images/demand.svg`}
                                                            className="img-fluid"
                                                            alt="demand"
                                                        />
                                                        <div>
                                                            <h5>{growth_project_manager_demand_title}</h5>
                                                            <h6>
                                                                {growth_project_manager_demand_description}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab>

                                        {/* Project Lead */}
                                        <Tab eventKey="project-lead" title="Project Lead">
                                            <Row>
                                                <Col md={6} className="tab-col-left">
                                                    <h4>{growth_project_lead_first_title}</h4>
                                                    <Image
                                                        src={growth_project_lead_first_image}
                                                        className="img-fluid"
                                                        alt="chart1"
                                                        title={
                                                            growth_project_lead_first_image_title ||
                                                            "Growth Project Lead First Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={6} className="tab-col-right">
                                                    <h4>{growth_project_lead_second_title}</h4>
                                                    <Image
                                                        src={growth_project_lead_second_image}
                                                        className="img-fluid"
                                                        alt="taimg"
                                                        title={
                                                            growth_project_lead_second_image_title ||
                                                            "Growth Project Lead Second Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={12} className="demand-box">
                                                    <h4>Demand</h4>
                                                    <div>
                                                        <Image
                                                            src={`${config.BASE_URL}/assets/images/demand.svg`}
                                                            className="img-fluid"
                                                            alt="demand"
                                                        />
                                                        <div>
                                                            <h5>{growth_project_lead_demand_title}</h5>
                                                            <h6>{growth_project_lead_demand_description}</h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab>

                                        {/* PMO Lead */}
                                        <Tab eventKey="pmo-lead" title="PMO Lead">
                                            <Row>
                                                <Col md={6} className="tab-col-left">
                                                    <h4>{growth_pmo_lead_first_title}</h4>
                                                    <Image
                                                        src={growth_pmo_lead_first_image}
                                                        className="img-fluid"
                                                        alt="chart1"
                                                        title={
                                                            growth_pmo_lead_first_image_title ||
                                                            "Growth Pmo Lead First Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={6} className="tab-col-right">
                                                    <h4>{growth_pmo_lead_second_title}</h4>
                                                    <Image
                                                        src={growth_pmo_lead_second_image}
                                                        className="img-fluid"
                                                        alt="taimg"
                                                        title={
                                                            growth_pmo_lead_second_image_title ||
                                                            "Growth Pmo Lead Second Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={12} className="demand-box">
                                                    <h4>Demand</h4>
                                                    <div>
                                                        <Image
                                                            src={`${config.BASE_URL}/assets/images/demand.svg`}
                                                            className="img-fluid"
                                                            alt="demand"
                                                        />
                                                        <div>
                                                            <h5>{growth_pmo_lead_demand_title}</h5>
                                                            <h6>{growth_pmo_lead_demand_description}</h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab>

                                        {/* Project Director */}
                                        <Tab eventKey="project-director" title="Project Director">
                                            <Row>
                                                <Col md={6} className="tab-col-left">
                                                    <h4>{growth_project_director_first_title}</h4>
                                                    <Image
                                                        src={growth_project_director_first_image}
                                                        className="img-fluid"
                                                        alt="chart1"
                                                        title={
                                                            growth_project_director_first_image_title ||
                                                            "Growth Project Director First Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={6} className="tab-col-right">
                                                    <h4>{growth_project_director_second_title}</h4>
                                                    <Image
                                                        src={growth_project_director_second_image}
                                                        className="img-fluid"
                                                        alt="taimg"
                                                        title={
                                                            growth_project_director_second_image_title ||
                                                            "Growth Project Director Second Image Title"
                                                        }
                                                    />
                                                </Col>
                                                <Col md={12} className="demand-box">
                                                    <h4>Demand</h4>
                                                    <div>
                                                        <Image
                                                            src={`${config.BASE_URL}/assets/images/demand.svg`}
                                                            className="img-fluid"
                                                            alt="demand"
                                                        />
                                                        <div>
                                                            <h5>{growth_project_director_demand_title}</h5>
                                                            <h6>
                                                                {growth_project_director_demand_description}
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Tab>
                                    </Tabs>
                                </Col>
                            </Row>

                            {/* Frequently Asked Quesions Sections */}
                            <Row className="cousrse-tab-accordian" id="ccb8">
                                <Col md={12} className="cta-top">
                                    <h3>{faq_title}</h3>
                                </Col>
                                <Col md={12}>
                                    <Row>
                                        <Col sm={12}>
                                            <div className={"cta-acc-box"}>
                                                <Accordion defaultActiveKey="0">
                                                    {loading ? (
                                                        <Accordion.Item>Loading...</Accordion.Item>
                                                    ) : error ? (
                                                        <Accordion.Item>{error}</Accordion.Item>
                                                    ) : faqData.length > 0 ? (
                                                        faqData.map((item, index) => (
                                                            <Accordion.Item
                                                                id={item.id}
                                                                key={index}
                                                                eventKey={index.toString()}
                                                            >
                                                                <Accordion.Header>
                                                                    {index + 1}. {item.name}
                                                                </Accordion.Header>
                                                                <Accordion.Body>
                                                                    <p
                                                                        dangerouslySetInnerHTML={createMarkup(
                                                                            item.description
                                                                        )}
                                                                    ></p>
                                                                </Accordion.Body>
                                                            </Accordion.Item>
                                                        ))
                                                    ) : (
                                                        <Accordion.Item>
                                                            <p>No Frequently Asked Quesions found.</p>
                                                        </Accordion.Item>
                                                    )}
                                                </Accordion>
                                            </div>
                                            {faqData.length < total_faq && (
                                                <div className="lpvm-btn">
                                                    <Link onClick={faq_handleViewMore}>View More</Link>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>

                            <Row className="tb-main mx-0">
                                <Col>
                                    <Row>
                                        <Col md={12}>
                                            <h3>Trusted By</h3>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="tb-box">
                                            <Slider {...settings1}>
                                                {loading && <div>Loading...</div>}
                                                {!loading && error && <div>{error}</div>}
                                                {!loading &&
                                                    !error &&
                                                    trustedbydata.map((item, index) => (
                                                        <Image
                                                            src={item.image}
                                                            className="img-fluid"
                                                            alt="trusted-by"
                                                            id={item.id}
                                                            key={index}
                                                        />
                                                    ))}
                                            </Slider>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={4} lg={4} className="cousrse-sidebar">
                            <Row>
                                <Col md={12}>
                                    <div className="cou-sidebar-form">
                                        {/* Talk to our advisor form */}

                                        <Form>
                                            <Form.Group className="mb-3" controlId="formGridPassword">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Full Name*"
                                                    value={talk_fullname}
                                                    onChange={(e) => setTalk_Fullname(e.target.value)}
                                                />

                                                {/* Full Name validation */}
                                                {errors.talk_fullname && (
                                                    <div className="text-danger">
                                                        {errors.talk_fullname}
                                                    </div>
                                                )}
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="formGridAddress1">
                                                <Form.Control
                                                    type="email"
                                                    placeholder="Email*"
                                                    value={talk_email}
                                                    onChange={(e) => setTalk_Email(e.target.value)}
                                                />

                                                {/* Email validation */}
                                                {errors.talk_email && (
                                                    <div className="text-danger">{errors.talk_email}</div>
                                                )}
                                            </Form.Group>
                                            <Form.Group className="mb-3" controlId="formGridAddress2">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Phone Number"
                                                    value={talk_phonenumber}
                                                    onChange={(e) => setTalk_Phonenumber(e.target.value)}
                                                />

                                                {/* Phone number validation */}
                                                {errors.talk_phonenumber && (
                                                    <div className="text-danger">
                                                        {errors.talk_phonenumber}
                                                    </div>
                                                )}
                                            </Form.Group>
                                            <p>
                                                By Signing up, you agree to our{" "}
                                                <Link
                                                    to="/terms-and-conditions"
                                                    onClick={() => window.scrollTo(0, 0)}
                                                >
                                                    Terms & Conditions
                                                </Link>{" "}
                                                and our{" "}
                                                <Link
                                                    to="/privacy-policy"
                                                    onClick={() => window.scrollTo(0, 0)}
                                                >
                                                    Privacy and Policy
                                                </Link>
                                            </p>

                                            <Button
                                                variant="primary"
                                                type="button"
                                                onClick={talk_submit}
                                                disabled={isSubmittingTalk}
                                            >
                                                {isSubmittingTalk ? (
                                                    <>
                                                        <Spinner
                                                            as="span"
                                                            animation="border"
                                                            size="sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                            className="mx-2"
                                                        />
                                                        Loading...
                                                    </>
                                                ) : (
                                                    "Talk to our advisor"
                                                )}
                                            </Button>
                                        </Form>
                                    </div>
                                    <div className="cou-quote">
                                        <div>
                                            <Image
                                                src={`${config.BASE_URL}/assets/images/queemoji.svg`}
                                                className="img-fluid"
                                                alt="queemoji"
                                            />
                                            <div>
                                                <h5>Struggling to Find the</h5>
                                                <h6>Perfect Schedule?</h6>
                                            </div>
                                        </div>
                                        <Link
                                            to={`/view-schedule/${courseid}`}
                                            onClick={() => window.scrollTo(0, 0)}
                                        >
                                            View all schedule
                                        </Link>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="sasu-box">
                {loading ? (
                    <Container>Loading...</Container>
                ) : error ? (
                    <Container>{error}</Container>
                ) : (
                    <Container>
                        <Row>
                            {coursestudentData.length === 0 ? (
                                ""
                            ) : (
                                <Col>
                                    <h3 className="sasu-title">Students also signed up for</h3>
                                </Col>
                            )}
                        </Row>
                        <Row>
                            {coursestudentData.map((item, index) => (
                                <Col md={4} key={index} className="pcbox">
                                    <div>
                                        <div className="pctop">
                                            <span>{item.category_name}</span>
                                            <NavLink href={`/${item.category_seo_slug}/${item.seo_slug}`}>
                                                <Image
                                                    src={item.image}
                                                    className="img-fluid"
                                                    alt="pc1"
                                                    title={item.image_title || "Image Title"}
                                                />
                                            </NavLink>
                                            <Image
                                                src={item.certified_image}
                                                className="img-fluid pct-abt"
                                                alt="sa"
                                                title={
                                                    item.certified_image_title || "Certified Image Title"
                                                }
                                            />
                                        </div>
                                        <div className="pcbot">
                                            <Col>
                                                <Col className="pcbotwrap">
                                                    <NavLink
                                                        href={`/${item.category_seo_slug}/${item.seo_slug}`}
                                                    >
                                                        <h3>{item.name}</h3>
                                                    </NavLink>
                                                    <Row>
                                                        <Col className="pcbottxt">
                                                            <Image
                                                                src={`${config.BASE_URL}/assets/images/pctime.png`}
                                                                className="img-fluid"
                                                                alt="pctime"
                                                            />
                                                            <p>100% assured results</p>
                                                        </Col>
                                                        <Col className="pcbottxt">
                                                            <Image
                                                                src={`${config.BASE_URL}/assets/images/pctime.png`}
                                                                className="img-fluid"
                                                                alt="pctime"
                                                            />
                                                            <p>{item.published_date}</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col className="pcbottxt">
                                                            <Image
                                                                src={`${config.BASE_URL}/assets/images/pcuser.png`}
                                                                className="img-fluid"
                                                                alt="pcuser"
                                                            />
                                                            <p>Bonus: {item.bonus}</p>
                                                        </Col>
                                                        <Col className="pcbottxt">
                                                            <Image
                                                                src={`${config.BASE_URL}/assets/images/pcuser.png`}
                                                                className="img-fluid"
                                                                alt="pcuser"
                                                            />
                                                            <p>{item.training_days} Days Training</p>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <div className="col pb-rate-view">
                                                            <div className="rating_bar">
                                                                <div
                                                                    className="rating-dis"
                                                                    style={{
                                                                        width: `${getRatingPercentage(
                                                                            item.rating
                                                                        )}%`,
                                                                    }}
                                                                ></div>
                                                            </div>
                                                            <p>({item.rating} Reviews)</p>
                                                        </div>
                                                    </Row>
                                                    <Row className="pbplwrap">
                                                        <Col className="pbprice pe-0">
                                                            <h4>₹ {formatNumber(item.fee)}</h4>
                                                            <h5>₹{formatNumber(item.discount_fee)}</h5>
                                                        </Col>
                                                        <Col className="pblink text-end">
                                                            <Nav.Link
                                                                href={`/${item.category_seo_slug}/${item.seo_slug}`}
                                                            >
                                                                Buy Course
                                                            </Nav.Link>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Col>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                )}
            </section>

            {/* Download Syllabus Form */}
            <Modal
                show={showsyll}
                onHide={handleCloseSyll}
                centered
                className="ebook-popup"
                backdrop="static"
            >
                <Modal.Body>
                    <Col className="ep-top">
                        <h3>Download Syllabus</h3>
                        <Link onClick={handleCloseSyll} state={{ id: courseid }}>
                            <Image
                                src={`${config.BASE_URL}/assets/images/close.png`}
                                className="img-fluid"
                                alt="close"
                            />
                        </Link>
                    </Col>
                    <Col>
                        <Form>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="fname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter First Name"
                                        value={sfirstname}
                                        onChange={(e) => setSFirstname(e.target.value)}
                                    />

                                    {/* First Name validation */}
                                    {errors.sfirstname && (
                                        <div className="text-danger">{errors.sfirstname}</div>
                                    )}
                                </Form.Group>
                                <Form.Group as={Col} controlId="lname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Last Name"
                                        value={slastname}
                                        onChange={(e) => setSLastname(e.target.value)}
                                    />

                                    {/* Last Name validation */}
                                    {errors.slastname && (
                                        <div className="text-danger">{errors.slastname}</div>
                                    )}
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter Email"
                                    value={semail}
                                    onChange={(e) => setSEmail(e.target.value)}
                                />

                                {/* Email validation */}
                                {errors.semail && (
                                    <div className="text-danger">{errors.semail}</div>
                                )}
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="phone">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Phone Number"
                                    value={sphonenumber}
                                    onChange={(e) => setSPhonenumber(e.target.value)}
                                />

                                {/* Contact validation */}
                                {errors.sphonenumber && (
                                    <div className="text-danger">{errors.sphonenumber}</div>
                                )}
                            </Form.Group>

                            {/* Submit Button And Loding Spinners  */}
                            <Button
                                variant="primary"
                                type="button"
                                onClick={syllabus_submit}
                                disabled={isSubmittingSyllabus}
                            >
                                {isSubmittingSyllabus ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="mx-2"
                                        />
                                        Loading...
                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </Button>
                        </Form>
                    </Col>
                </Modal.Body>
            </Modal>

            {/* Download Curriculum Form */}
            <Modal
                show={show}
                onHide={handleClose}
                centered
                className="ebook-popup"
                backdrop="static"
            >
                <Modal.Body>
                    <Col className="ep-top">
                        <h3>Download Curriculum</h3>
                        <Link onClick={handleClose} state={{ id: courseid }}>
                            <Image
                                src={`${config.BASE_URL}/assets/images/close.png`}
                                className="img-fluid"
                                alt="close"
                            />
                        </Link>
                    </Col>
                    <Col>
                        <Form>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="fname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter First Name"
                                        value={cfirstname}
                                        onChange={(e) => setCFirstname(e.target.value)}
                                    />

                                    {/* First Name validation */}
                                    {errors.cfirstname && (
                                        <div className="text-danger">{errors.cfirstname}</div>
                                    )}
                                </Form.Group>

                                <Form.Group as={Col} controlId="lname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter Last Name"
                                        value={clastname}
                                        onChange={(e) => setCLastname(e.target.value)}
                                    />

                                    {/* Last Name validation */}
                                    {errors.clastname && (
                                        <div className="text-danger">{errors.clastname}</div>
                                    )}
                                </Form.Group>
                            </Row>

                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter Email"
                                    value={cemail}
                                    onChange={(e) => setCEmail(e.target.value)}
                                />

                                {/* Email validation */}
                                {errors.cemail && (
                                    <div className="text-danger">{errors.cemail}</div>
                                )}
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="phone">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter Phone Number"
                                    value={cphonenumber}
                                    onChange={(e) => setCPhonenumber(e.target.value)}
                                />

                                {/* Phone number validation */}
                                {errors.cphonenumber && (
                                    <div className="text-danger">{errors.cphonenumber}</div>
                                )}
                            </Form.Group>

                            {/* Submit Button And Loding Spinners  */}
                            <Button
                                variant="primary"
                                type="button"
                                onClick={curriculum_submit}
                                disabled={isSubmittingCurriculum}
                            >
                                {isSubmittingCurriculum ? (
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className="mx-2"
                                        />
                                        Loading...
                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </Button>
                        </Form>
                    </Col>
                </Modal.Body>
            </Modal>

            {/* Skill up your team form modal */}
            <Modal
                show={showSkill}
                onHide={handleCloseSkill}
                centered
                className="skill-popup"
                backdrop="static"
            >
                <Modal.Body>
                    <Col className="skill-top">
                        <h3>Skill up your team</h3>
                        <Link onClick={handleCloseSkill}>
                            <Image
                                src={`${config.BASE_URL}/assets/images/close.png`}
                                className="img-fluid"
                                alt="close"
                            />
                        </Link>
                    </Col>
                    <Col>
                        <Form>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="fname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter first name"
                                        value={skill_firstname}
                                        onChange={(e) => setSkill_Firstname(e.target.value)}
                                    />

                                    {/* First Name validation */}
                                    {errors.skill_firstname && (
                                        <div className="text-danger">{errors.skill_firstname}</div>
                                    )}
                                </Form.Group>
                                <Form.Group as={Col} controlId="lname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter last name"
                                        value={skill_lastname}
                                        onChange={(e) => setSkill_Lastname(e.target.value)}
                                    />

                                    {/* Last Name validation */}
                                    {errors.skill_lastname && (
                                        <div className="text-danger">{errors.skill_lastname}</div>
                                    )}
                                </Form.Group>
                            </Row>
                            <Form.Group className="mb-3" controlId="email">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter your email"
                                    value={skill_email}
                                    onChange={(e) => setSkill_Email(e.target.value)}
                                />

                                {/* Email validation */}
                                {errors.skill_email && (
                                    <div className="text-danger">{errors.skill_email}</div>
                                )}
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="phone">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Enter your phone number"
                                    value={skill_phonenumber}
                                    onChange={(e) => setSkill_Phonenumber(e.target.value)}
                                />

                                {/* Phone Number validation */}
                                {errors.skill_phonenumber && (
                                    <div className="text-danger">{errors.skill_phonenumber}</div>
                                )}
                            </Form.Group>
                            <Row className="mb-3">
                                <Form.Group className="mb-3" controlId="query">
                                    <Form.Label>Query</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        placeholder="Enter query"
                                        value={skill_query}
                                        onChange={(e) => setSkill_Query(e.target.value)}
                                    />

                                    {/* Query validation */}
                                    {errors.skill_query && (
                                        <div className="text-danger">{errors.skill_query}</div>
                                    )}
                                </Form.Group>
                            </Row>
                            <Button variant="primary" onClick={skillup_submit}>
                                Submit
                            </Button>
                        </Form>
                    </Col>
                </Modal.Body>
            </Modal>

            <Modal
                show={showThank}
                onHide={handleCloseThank}
                centered
                className="thank-popup"
                backdrop="static"
            >
                <Modal.Body>
                    <Col>
                        <Image
                            src={`${config.BASE_URL}/assets/images/check-mark.png`}
                            className="img-fluid"
                            alt="check-mark"
                        />
                        <h3>Thank You!</h3>
                        <p>Your details has been successfully submitted. Thanks!</p>
                        <Link onClick={handleCloseThank}>OK</Link>
                    </Col>
                </Modal.Body>
            </Modal>

            <Footer />
        </>
    );
};
export default CourseDetail;
